import * as React from "react";
import { clearedDreamFilters } from "source/app/presentation/MainPanel/Dreams/DreamFilterButtons/Helpers/clearedDreamFilters";
import Dreams from "source/app/presentation/MainPanel/Dreams/Dreams";
import { EGlyphicon } from "source/app/presentation/Shared/Glyphicon/EGlyphicon";
import Render from "source/app/presentation/Shared/Render";
import IconWithText from "source/app/services/Shared/IconWithText/IconWithText";
import { ShouldDreamBeReviewed } from "source/app/presentation/MainPanel/Dreams/Controls/Difficulty/ReviewIcon/DreamReviewIcon";
import { NavigateToDreamsRoute } from "../../Routing/DreamsRouting";

export function ShowReviews({ dreams }: { dreams: Dreams }) {
    const reviewOnlyFilters = {
        ...clearedDreamFilters,
        onlyShowDreamsToReview: true,
    };

    const numberOfDreamsToReview = dreams
        ? dreams.state.dreamsdata.filter((dream) =>
              ShouldDreamBeReviewed(dream)
          ).length
        : 0;

    return (
        <Render id="showDreamsToReviewButton" when={numberOfDreamsToReview > 0}>
            <span id="showDreamsToReview">
                <IconWithText
                    iconSuffix={EGlyphicon["eye-open"]}
                    whenClicked={() => {
                        NavigateToDreamsRoute(`Reviews`);
                        dreams.setState(reviewOnlyFilters);
                    }}
                    displayAsBlock={false}
                >
                    {`${numberOfDreamsToReview} to review`}
                </IconWithText>
            </span>
        </Render>
    );
}
